import { useEffect, useState } from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { useStyles } from 'components/OrderSlidesList/SlideActionTabs/SlideMetadata/styles';
import { useSelector } from 'react-redux';
import {
  isExpandedBottomSelector,
  isExpandedTopSelector,
  slidesListOrderSelector,
} from 'store/slices/slidesListSlice/slidesListSlice';
import _ from 'lodash';
import {
  buildSearchLinkWithProps,
  getSampleScienceInfo,
} from 'components/OrderSlidesList/utilities';
import { SlideMetadataHeader } from 'components/PathologyMap/Modals/FullSlideInfoModal/SlideInfoSection/SlideMetadataHeader';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { SlideMetaDataTable } from 'components/OrderSlidesList/SlideActionTabs/SlideMetadata/SlideMetadataTable/SlideMetaDataTable';
import { getSlideMeta } from 'components/OrderSlidesList/SlideActionTabs/SlideMetadata/utils';
import { userDetailsSelector } from 'store/slices/userDetailsSlice';

export const SlideMetadata = ({ slide, isTop, isSlideCard }) => {
  const { classes } = useStyles({ isSlideCard });
  const order = useSelector(slidesListOrderSelector);
  const [currentTab, setCurrentTab] = useState(0);
  const [sampleData, setSampleData] = useState([]);
  const [metaData, setMetaData] = useState([]);
  const isInitialTab = !currentTab;
  const { isStaff } = useSelector(userDetailsSelector);

  const getMetaData = () => {
    const slideMeta = getSlideMeta(slide, order, isStaff);
    setMetaData(slideMeta);
  };

  useEffect(() => {
    getMetaData();
  }, [slide]);

  const scienceInfo = slide?.sample?.science_info || {};

  const scienceInfoItems = getSampleScienceInfo(scienceInfo);
  const isExpandedTop = useSelector(isExpandedTopSelector);
  const isExpandedBottom = useSelector(isExpandedBottomSelector);
  const isExpanded = isTop ? isExpandedTop : isExpandedBottom;

  useEffect(() => {
    if (!slide?.sample || isInitialTab || sampleData.length) return;

    if (!_.isEmpty(scienceInfo)) {
      setSampleData(scienceInfoItems);
    }
  }, [isInitialTab, slide?.sample, sampleData]);

  const handleTabsChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const handleNavigateToSearchPage = () => {
    const pathologyMapSearchURL = buildSearchLinkWithProps(slide);

    window.open(pathologyMapSearchURL, '_blank');
  };

  return (
    <>
      <SlideMetadataHeader
        slide={slide}
        currentTab={currentTab}
        handleTabsChange={handleTabsChange}
        standardMetadataItemsCount={metaData?.length}
        scienceInfoItemsCount={scienceInfoItems?.length}
        isOrderSlide={!isSlideCard}
        isTop={isTop}
        isSlideCard={isSlideCard}
        isExpanded={isExpanded}
        getMetaData={getMetaData}
      />
      <SlideMetaDataTable
        metaData={metaData}
        sampleData={sampleData}
        isInitialTab={isInitialTab}
        slide={slide}
        isStaff={isStaff}
        classes={classes}
      />
      {isInitialTab && (
        <Tooltip title="View Similar Slides in Search 2.0 (New Tab)">
          <Box
            className={classes.viewSimilarSlidesLinkBox}
            onClick={handleNavigateToSearchPage}
          >
            <Typography className={classes.viewSimilarSlidesLink}>
              View similar slides
            </Typography>
            <OpenInNewIcon className={classes.linkIcon} />
          </Box>
        </Tooltip>
      )}
    </>
  );
};
